module.exports = __webpack_public_path__ + "img/btn-play.d647d278.svg";